<template>
    <el-select
        filterable
        :filter-method="selectFilter"
        class="search-input"
        v-model="Datas"
        :placeholder="placeholders"
        :clearable="clearables"
        @change="myChange"
        ref="select"
        @hook:mounted="cancalReadOnly"
        @visible-change="visibleChange"
        :multiple="multiple"
        :disabled="disable"
        style="width: 100%"
    >
        <el-option
            v-for="(item, index) in untility"
            :key="item[keys] || index"
            :label="item[values] + '-' + item[labels] || item"
            :value="item[values] || item"
            :disabled="item['islock'] == 1 ? true : false || item.status == 0"
        >
            <span style="float: left; color: #8492a6; font-size: 13px; margin-right: 10px"
                ><el-tag style="margin-right: 10px" type="danger" v-if="item['islock'] == 1 ? true : false">锁定</el-tag
                >{{ item[values] || item }}</span
            >
            <span v-if="!single" style="float: right">{{ item[labels] }}</span>
        </el-option>
    </el-select>
</template>

<script>
export default {
    data() {
        return {
            // 选中时的数据
            Datas: '',
            // 临时存放的数组
            SelectNavTemporary: [],
            // 选做处理的 遍历的数组
            option: [],

            // 遍历的对象
            untility: []
        };
    },
    props: {
        value: {
            default: ''
        },
        // 初始搜索遍历的数组
        options: {
            type: Array,
            default: () => {
                [];
            }
        },
        single: {
            type: Boolean,
            default: false
        },
        values: {
            type: String,
            default: 'value'
        },
        labels: {
            type: String,
            default: 'label'
        },
        keys: {
            type: String,
            default: 'value'
        },
        clearables: {
            type: Boolean,
            default: true
        },
        placeholders: {
            type: String,
            default: '请选择'
        },
        width: {
            type: String,
            default: '200'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        options: {
            handler(n) {
                //
                // 监听初始遍历的数组变化并赋值给 option 以及 SelectNavTemporary
                if (n) {
                    this.untility = this.$deepClone(n.slice(0, 1000));
                    this.SelectNavTemporary = this.$deepClone(n);
                    this.option = this.$deepClone(n);
                }
            },
            deep: true,
            immediate: true
        },
        value: {
            handler(n) {
                this.Datas = n;
                //
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        // 判断是否为苹果手机
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端

        // 监听input
        this.$refs.select.$el.children[0].children[0].addEventListener('input', (dom) => {
            if (isiOS) {
                var val = dom.target.value;
                this.selectFilter(val);
            }
        });

        // 离开时销毁 input事件
        this.$once('hook:beforeDestroy', () => {
            if (isiOS) {
                this.$refs.select.$el.children[0].children[0].removeEventListener('input');
            }
        });
    },
    methods: {
        // 解决苹果手机不能唤起输入法
        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const { select } = this.$refs;
                    const input = select.$el.querySelector('.el-input__inner');
                    input.removeAttribute('readonly');
                }
            });
        },
        visibleChange(onOff) {
            if (!onOff) {
                // 开
                if (!this.untility.length) {
                    this.untility = this.$deepClone(this.options.slice(0, 300));
                    this.SelectNavTemporary = this.$deepClone(this.options);
                    this.option = this.$deepClone(this.options);
                }
            } else {
                // 关
                setTimeout(() => {
                    this.untility = this.options;
                }, 200);
            }
            this.cancalReadOnly();
        },
        // select 搜索逻辑
        selectFilter(val) {
            //判断是否为空
            if (val) {
                //同时筛选Lable与value的值
                this.option = this.SelectNavTemporary.filter((item) => {
                    // 1.判断 this.labels | this.values 是否为空，为空这不判断这两个
                    if (!item[this.values]) {
                        // 假如 item[this.values] 为空
                        if (!!~item[this.labels].indexOf(val) || !!~item[this.labels].toUpperCase().indexOf(val.toUpperCase())) {
                            return true;
                        }
                    } else if (!item[this.labels]) {
                        // 假如 item[this.labels] 为空
                        if (!!~item[this.values].indexOf(val) || !!~item[this.values].toUpperCase().indexOf(val.toUpperCase())) {
                            return true;
                        }
                    } else {
                        // 两值都用
                        if (
                            !!~item[this.values].indexOf(val) ||
                            !!~item[this.values].toUpperCase().indexOf(val.toUpperCase()) ||
                            !!~item[this.labels].indexOf(val) ||
                            !!~item[this.labels].toUpperCase().indexOf(val.toUpperCase())
                        ) {
                            return true;
                        }
                    }
                });

                // 解决数据太多卡顿，当数据大于 300 时只加载 300 条
                if (this.option.length > 300) {
                    this.untility = this.$deepClone(this.option.slice(0, 300));
                } else {
                    this.untility = this.$deepClone(this.option);
                }
            } else {
                //赋值还原
                this.option = this.$deepClone(this.SelectNavTemporary);

                this.untility = this.$deepClone(this.option.slice(0, 300));
            }
        },
        myChange(val) {
            // 丢出
            this.$emit('selectChange', this.Datas);
            this.$emit('input', this.Datas);
            this.$forceUpdate();
        }
    }
};
</script>
